<template>
	<div class="sscw-click-wizard">
		<div class="sscw-stepper sscw-container">
			<div id="progressBar" class="sscw-stepper-progress-container">
				<div class="sscw-stepper-progress">
					<div class="sscw-progress-bar">
						<div class="sscw-progress-bar-fill" :style="{ width: `${progressPercent}%` }"></div>
						<div class="sscw-progress-bar-empty"></div>
					</div>
				</div>
			</div>
			<div class="subtitle-row">
				<div class="sscw-stepper-subtitle">Schritt {{ Math.floor(step + 2-1) }} von {{ maxStep + 2 -1}}</div>
				<div v-if="!isMobile" class="sscw-stepper-subtitle">
					{{ step < 4 ? " " : " " }}
				</div>
			</div>
		</div>

		<div :class="{ 'sscw-steps-container': true }">
			<slot></slot>
		</div>

		<div class="sscw-bottom-navigation">
			<div class="sscw-bottom-navigation-buttons sscw-container">
				<div
					@click="nextNavigation"
					:id="`nextNavigation-step-${this.step}`"
					class="sscw-navigation-button next-button"
					:class="{
						'cant-navigate': !this.isCurrentStepValid,
						'can-navigate': this.isCurrentStepValid,
						'sscw-navigation-last-button': step == maxStep,
					}"
				>
					<div class="sscw-navigation-button-text next-text">
						<span>{{ 
							
							this.step ==4?"Kontakt abgeben":
							this.step < this.maxStep ? "Weiter" : "Werteinschätzung anfordern" }}</span>
					</div>
					<div class="sscw-right-arrow">
						<img class="sscw-right-arrow-img" src="../../../static/keyboard-arrow-right.svg" alt="next" />
					</div>
				</div>

				<div
					@click="backNavigation"
					:id="`backNavigation-step-${this.step}`"
					:class="{
						'sscw-back-navigation-button': true,
						'back-button': true,
						'sscw-back-disable': !allowBackNavigation,
					}"
				>
					<div class="sscw-left-arrow">
						<img class="sscw-left-arrow-img" :src="theme.leftArrowIcon" alt=" previous" />
					</div>
					<span class="sscw-mobile-hidden">Zurück</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import getTheme from "@/utils/theme";
import Vue from "vue";

export default {
	name: "ClickWizardStepper",
	data() {
		return {
			theme: getTheme(),
			windowWidth: null,
			step: 0,
			maxStep: 5,
			transition: null,
			allowBackNavigation: true,
			calculatingTime: 7600,
		};
	},
	computed: {
		isCurrentStepValid() {
			return this.$store.isCurrentStepValid;
		},
		isMobile() {
			if (this.windowWidth < 768) {
				return true;
			}
			return false;
		},
		progressPercent() {
			if (this.step == 0) {
				return 10;
			}
			return (this.step / this.maxStep) * 100;
		},
	},
	watch: {
		step(nextStep, previousStep) {
			this.emitUpdate({ nextStep, previousStep });
		},
		transition() {
			this.emitUpdate();
		},
	},
	created() {
		this.windowWidth = window.innerWidth;
		this.emitUpdate();
	},
	mounted() {
		window.addEventListener("resize", () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		handleGoHome() {
			window.location.href = "/";
		},
		emitUpdate(params = {}) {
			const { previousStep } = params;

			this.$emit("onStepChange", {
				previousStep,
				step: this.step,
				transition: this.transition,
			});
		},
		backNavigation() {
			if (this.allowBackNavigation) {
				if (this.step > 0) {
					this.transition = "slide-prev";
					Vue.nextTick(() => {
						this.step--;
					});
				}
				if (this.step == 0) {
					this.handleGoHome();
				}
			}
		},
		nextNavigation() {
			if (this.$store.isCurrentStepValid) {
				if (this.step < this.maxStep) {
					this.transition = "slide-next";

					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: `extnWizard_step${this.step + 1}`,
						location: "click_wizard",
					});
					return this.step++;
				}
				if (this.step == this.maxStep) {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: `extnWizard_step${this.step + 1}`,
						location: "click_wizard",
					});
					this.$emit("onFinishStepper");
				}
			}
		},
		handleAcceptOffer() {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "step5AcceptOffer",
				location: "click_wizard",
			});
			this.$store.wizardState.requestOffer = true;
			this.nextNavigation();
		},
		handleDeclineOffer() {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "step5DeclineOffer",
				location: "click_wizard",
			});
			this.$store.wizardState.requestOffer = false;
			this.nextNavigation();
		},
	},
};
</script>
<style>
.step5-request-offer-container {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.acept-offer-button {
	cursor: pointer;
	background: #112c42;
	border-radius: 10px;
	padding: 18px;

	font-family: Inter;
	font-size: 16px;
	font-weight: 500;
	line-height: 21px;
	letter-spacing: 0em;
	text-align: left;
	color: white;

	flex: 1;
}

.offer-decline-button {
    cursor: pointer;
    padding: 18px;
      cursor: pointer;
    font-family: Inter;
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    border: 2px solid #f2f5f7;
    border-radius: 10px;
    flex: 1;
}

.mobile-back-decline {
	display: flex;
	align-items: center;
	flex-direction: row;
	gap: 10px;
}

.step5-back-button {
	height: 23px;
	cursor: pointer;
	font-family: Inter;
	font-size: 16px;
	font-weight: 400;
	line-height: 21px;
	letter-spacing: 0em;
	text-align: left;
	background-color: #f2f5f7;
	border-radius: 10px;
	padding: 18px;
}

sscw-left-arrow-img {
	margin: auto;
}

@media (min-width: 1190px) {
	.step5-request-offer-container {
		flex-direction: row;
		gap: 10px;
		align-items: center;
	}

	.mobile-back-decline {
		display: none;
	}
}

.title {
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}

.subtitle-row {
	display: flex;
	justify-content: space-between;
	margin-top: 19px;
}

.cant-navigate {
	background-color: gray;
}

.can-navigate {
	background-color: #0646EA;
}
</style>
